import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, useMediaQuery, useTheme, Toolbar } from '@mui/material';
import HeaderNav from '../HeaderNav';
import LeftSidebar from '../LeftSidebar';
import FooterNav from '../FooterNav';
import ScrollToTop from '../ScrollToTop';

const AppLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Determine if we should show the header based on the current route
  const mainContentRoutes = ['/', '/allsports', '/odds', '/live-games', '/handicappers', '/podcasts', '/chat', '/promos', '/admin', '/handicapper-dashboard', '/resources'];
  const showHeader = mainContentRoutes.includes(location.pathname) || location.pathname.startsWith('/sport/') || location.pathname.startsWith('/player-props');

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default', position: 'relative' }}>
      <ScrollToTop />

      {/* Header - Full width across viewport */}
      {showHeader && (
        <>
          <HeaderNav onMenuToggle={handleSidebarToggle} />
          {/* Spacer to prevent content from hiding under fixed header */}
          <Toolbar sx={{ minHeight: { xs: 60, sm: 72 } }} />
        </>
      )}

      {/* Content Area with Sidebar */}
      <Box sx={{ display: 'flex', flexGrow: 1, minHeight: 0 }}>
        {/* Left Sidebar */}
        {showHeader && (
          <LeftSidebar open={sidebarOpen} onClose={handleSidebarClose} />
        )}

        {/* Main Content Area */}
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
          {/* Page Content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: { xs: 2, sm: 3 },
              maxWidth: '1400px',
              mx: 'auto',
              width: '100%',
            }}
          >
            <Outlet />
          </Box>

          {/* Footer */}
          <FooterNav />
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;